import React, {Fragment} from 'react';
import Box from '../layout/Box';
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import {
    BarcodeFormatter,
    CurrencyFormatter, optionsTemplate, ProductColumn,
    UnitFormatter
} from "../../utils/formatters";
import BoxEditor from "./BoxEditor";
import Select from "../form/Select";
import {loadComponent} from "../../utils/components";
import ComponentConfig from "../form/ComponentConfig";
import {connect} from "src/store";
import ComponentLoader from "../form/ComponentLoader";
import Button from "../form/Button";
import {paramsSerializer, UrlGenerator} from "../../utils/request";
import {setContent} from "../../actions";

class ShopItemStockEditor extends React.Component {

    state = {
        filter: ["store"],
        locations: []
    };

    componentDidMount() {
        this.reloadLocations();
    }

    reloadLocations = () => {
        if (!this.state.locations.length) {
            this.setState({}, async () => {
                const allLocation = await loadComponent("componentlist", {
                    component: "location",
                    itemsperpage: 0,
                    view: [this.props.locationConfig.idfield],
                    filter: [
                        {
                            filters: [
                                {
                                    field: "roles.optionid",
                                    value: "3" // 4 - ShopSupplyStore
                                },
                                {
                                    field: "roles.optionid",
                                    value: "6" // 4 - ShopSupplyStore
                                }
                            ],
                            operator: "OR"
                        },
                        {
                            field: "partner",
                            value: this.props.PointOfSale.partner.partner_id
                        }
                    ]
                });
                this.setState({locations: allLocation.items});
            });
        }
    }

    render() {
        const partner_id = this.props.PointOfSale.partner.partner_id;
        const product_id = this.state.product_id;
        const author_id = this.state.author_id;
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const sortable = true;
        const filterable = true;
        const columns = {
            "displayname": {
                ...ProductColumn("id"),
                width: 3,
            },
            "category.name": {
                header: 'Árutípus',
                width: 1,
                sortable,
                filterable
            },
            "sku": {
                header: 'ISBN',
                width: 1,
                sortable,
                filterable
            },
            "barcode": {
                header: 'Vonalkód',
                width: 1,
                sortable,
                filterable
            },
            "listprice": {
                header: 'Listaár',
                width: 1,
                sortable,
                filterable,
                className: "currency",
                renderer: CurrencyFormatter
            },
            "qty": {
                header: 'Darabszám',
                width: 1,
                sortable,
                filterable,
                renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                className: "unit"
            },
            "shadowqty": {
                header: '- Hiány/ + Többlet',
                width: 1,
                sortable,
                filterable,
                renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                className: "unit"
            },
            "store.name": {
                header: 'Raktár',
                width: 2,
                sortable,
                filterable
            },
            "authors": {
                header: 'Szerzők',
                width: 2,
                renderer: (authors) => {
                    return authors.map((author) => author.name).reduce((prev, curr) => [prev, prev ? ', ' : '', curr], null)
                }
            }
        };
        let filter;
        if (product_id) {
            filter = [
                {
                    field: "partner",
                    value: partner_id
                },
                {
                    field: "base_product_id",
                    value: product_id
                },
                {
                    field: "store",
                    value: this.state.locations.map((location) => location[this.props.locationConfig.idfield]),
                    operator: "in"
                }
            ];
        } else {
            filter = [
                {
                    field: "partner",
                    value: partner_id
                },
                {
                    field: "authors.author_id",
                    value: author_id
                },
                {
                    field: "store",
                    value: this.state.locations.map((location) => location[this.props.locationConfig.idfield]),
                    operator: "in"
                }
            ];
        }
        return (
            <Fragment>
                <List
                    theme="default"
                    header="Termék készlet"
                    footer={this.props.location && <Fragment>
                        <Button
                            color="default"
                            onClick={() => {
                                this.props.setContent("ShopPromotions", {});
                            }}
                        >
                            Akciós termék lista
                        </Button>
                    </Fragment>}
                >
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <Select
                                    name="product"
                                    objectValue={true}
                                    component="product"
                                    labelKey="displayname"
                                    valueKey="base_product_id"
                                    optionsTemplate={optionsTemplate("product")}
                                    isClearable={true}
                                    autoSelect={true}
                                    saveChanges={(field, value) => {
                                        this.setState({product_id: (value || {}).base_product_id, author_id: undefined});
                                    }}
                                    storeType="remote"
                                    label="Termék"
                                    searchFormatter={BarcodeFormatter}
                                    placeholder="Vonalkód vagy cím"
                                    value={product_id}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <Select
                                    component="author"
                                    objectValue={true}
                                    valueKey="id"
                                    labelKey="name"
                                    storeType="remote"
                                    label="Szerző"
                                    isClearable={true}
                                    autoSelect={true}
                                    optionsTemplate={optionsTemplate("author")}
                                    saveChanges={(field, value) => {
                                        this.setState({product_id: undefined, author_id: (value || {}).id});
                                    }}
                                    value={author_id}
                                />
                            </div>
                        </div>
                    </div>
                    {(product_id || author_id) && <SelectorGrid
                        gridid={this.props.gridid || "stockList"}
                        className={"p-small-table"}
                        loading={this.props.isLoading}
                        component="StockItem"
                        view={[...Object.keys(columns), "id"]}
                        exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel", addFilters: true}]}
                        aggregations={{
                            fields: {
                                "qty": {
                                    field: "qty", type: "SUM"
                                }
                            }
                        }}
                        columns={columns}
                        filter={filter}
                        pageSize={50}
                        // kell az id mivel nincs idfield...
                        orderBy={{field: "id", direction: "DESC"}}
                    />}
                </List>
            </Fragment>
        );
    }
}

const PosEditor = connect((state) => {
    return {
        till: state.app.till,
        location: state.app.till?.pos?.location,
    }
}, {setContent})((props) => {
    if (!props?.till?.pos?.id) {
        return <Box header="Hiba" theme="danger">
            Nem boltba vagy bejelentkezve!
        </Box>;
    }
    return <ComponentLoader
    componentName="PointOfSale"
    componentId={props.till.pos.id}
    view={["partner"]}
    dynamic={true}
>
    <ShopItemStockEditor {...props}/>
</ComponentLoader>
});

export default (props) => <ComponentConfig
    componentName="location"
    componentConfigAs="locationConfig"
>
    <PosEditor {...props} />
</ComponentConfig>;

